import IUserUI from "../models/IUserUI";
import ISupplierModel from "../models/ISupplierModel";
import IVendorModel from "../models/IVendorModel";
import RestEndpointsEnum from "../models/RestEndpointsEnum";
import { buildRestUrlWithQuery, buildAuthHeadersForFetch } from "./RestService";
import IOnGetSerialsDTO from "../models/DTO/IOnGetSerialsDTO";
import IGetSerialsQuery from "@models/DTO/IGetSerialsQuery";
import IBulkAssignSerialsDTO from "../models/DTO/IBulkAssignSerialsDTO";

const getSerials = async (
    query: IGetSerialsQuery,
    userModel: IUserUI,
    supplierModel: ISupplierModel,
    vendorModel?: IVendorModel
): Promise<IOnGetSerialsDTO> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.SerialsGetAll,
        query,
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
        vendorModel,
    });

    const response = await fetch(url, {
        method: "GET",
        headers,
    });

    if (!response.ok) {
        throw new Error(`Failed to fetch serials: ${response.statusText}`);
    }

    return (await response.json()) as IOnGetSerialsDTO;
};

const bulkAssignSerials = async (
    dto: IBulkAssignSerialsDTO,
    userModel: IUserUI,
    supplierModel: ISupplierModel,
    vendorModel?: IVendorModel
): Promise<void> => {
    const url = buildRestUrlWithQuery({
        endpoint: RestEndpointsEnum.SerialsBulkAssign,
    });

    const headers = buildAuthHeadersForFetch({
        userModel,
        supplierModel,
        vendorModel,
    });

    const response = await fetch(url, {
        method: "POST",
        headers,
        body: JSON.stringify(dto),
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        throw new Error(errorData?.message || `Failed to bulk assign serials: ${response.statusText}`);
    }
};

const SerialService = {
    getSerials,
    bulkAssignSerials,
};

export default SerialService;
